
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-and-hospitality-software-development",
      function () {
        return require("private-next-pages/travel-and-hospitality-software-development.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-and-hospitality-software-development"])
      });
    }
  